import { DEFAULT_MEMORY_AUGMENTATION_PROMPT_TEMPLATE, DEFAULT_MEMORY_CREATION_PROMPT_TEMPLATE, getConversationMemoryEnabled, getConversationMemoryIncludeReferenceData, getMultiSessionMemoryEnabled, getMultiSessionMemoryCreationEnabled, getMultiSessionMemoryTypes, getMultiSessionMemoryTypeById } from "@/containers/ChatGPT/features/ConversationMemory/selectors";
import { getSelectedAccountId } from "@/containers/Accounts/reducer";
import { AibleClientFactory } from "@/client/aible/factory";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
/** Turn on or off the conversation memory feature. */
export function toggleConversationMemory() {
    return (dispatch, getState) => {
        const newValue = Boolean(!getConversationMemoryEnabled(getState()));
        const update = chatGPTReducer.updateField("conversationMemoryEnabled", newValue);
        if (localStorage) {
            localStorage.setItem("conversationMemoryEnabled", JSON.stringify(newValue));
        }
        return dispatch(update);
    };
}
export function updateConversationMemoryMessageLimit(num) {
    return (dispatch) => {
        const update = chatGPTReducer.updateField("conversationMemoryMessageLimit", num);
        if (localStorage) {
            localStorage.setItem("conversationMemoryMessageLimit", JSON.stringify(num));
        }
        return dispatch(update);
    };
}
/** Turn on or off whether conversation memory will load previous message reference data. */
export function toggleConversationMemoryIncludeReferenceData() {
    return (dispatch, getState) => {
        const newValue = Boolean(!getConversationMemoryIncludeReferenceData(getState()));
        const update = chatGPTReducer.updateField("conversationMemoryIncludeReferenceData", newValue);
        if (localStorage) {
            localStorage.setItem("conversationMemoryIncludeReferenceData", JSON.stringify(newValue));
        }
        return dispatch(update);
    };
}
/** Toggle the current state of enabling User Persona Memory  */
export function toggleMultiSessionMemory(skipLocalStorageUpdate = false) {
    return (dispatch, getState) => {
        const newValue = Boolean(!getMultiSessionMemoryEnabled(getState()));
        const update = chatGPTReducer.updateField("multiSessionMemoryEnabled", newValue);
        if (localStorage && !skipLocalStorageUpdate) {
            localStorage.setItem("multiSessionMemoryEnabled", JSON.stringify(newValue));
        }
        return dispatch(update);
    };
}
export function updateMultiSessionMemoryEnabled(newValue, skipLocalStorageUpdate = false) {
    return (dispatch, getState) => {
        const multiSessionMemoryEnabled = getMultiSessionMemoryEnabled(getState());
        if (newValue !== multiSessionMemoryEnabled) {
            const update = chatGPTReducer.updateField("multiSessionMemoryEnabled", newValue);
            if (localStorage && !skipLocalStorageUpdate) {
                localStorage.setItem("multiSessionMemoryEnabled", JSON.stringify(newValue));
            }
            return dispatch(update);
        }
        return;
    };
}
export function toggleMultiSessionMemoryCreation(skipLocalStorageUpdate = false) {
    return (dispatch, getState) => {
        const newValue = Boolean(!getMultiSessionMemoryCreationEnabled(getState()));
        const update = chatGPTReducer.updateField("multiSessionMemoryCreationEnabled", newValue);
        if (localStorage && !skipLocalStorageUpdate) {
            localStorage.setItem("multiSessionMemoryCreationEnabled", JSON.stringify(newValue));
        }
        return dispatch(update);
    };
}
export function updateMultiSessionMemoryCreationEnabled(newValue, skipLocalStorageUpdate = false) {
    return (dispatch, getState) => {
        const multiSessionMemoryCreationEnabled = getMultiSessionMemoryCreationEnabled(getState());
        if (newValue !== multiSessionMemoryCreationEnabled) {
            const update = chatGPTReducer.updateField("multiSessionMemoryCreationEnabled", newValue);
            if (localStorage && !skipLocalStorageUpdate) {
                localStorage.setItem("multiSessionMemoryCreationEnabled", JSON.stringify(newValue));
            }
            return dispatch(update);
        }
        return;
    };
}
export function updateMultiSessionMemoryTypes(memoryTypesUpdate, skipLocalStorageUpdate = false) {
    return (dispatch) => {
        const update = chatGPTReducer.updateField("multiSessionMemoryTypes", memoryTypesUpdate);
        if (localStorage && !skipLocalStorageUpdate) {
            localStorage.setItem("multiSessionMemoryTypes", JSON.stringify(memoryTypesUpdate));
        }
        return dispatch(update);
    };
}
export function updateMultiSessionMemoryType(id, memoryTypeUpdate, skipLocalStorageUpdate = false) {
    return (dispatch, getState) => {
        const multiSessionMemoryTypes = getMultiSessionMemoryTypes(getState());
        const newTypes = {
            ...multiSessionMemoryTypes,
            [id]: memoryTypeUpdate
        };
        const update = updateMultiSessionMemoryTypes(newTypes, skipLocalStorageUpdate);
        return dispatch(update);
    };
}
export function updateMultiSessionMemoryTypeSetting(id, setting, settingUpdate, skipLocalStorageUpdate = false) {
    return (dispatch, getState) => {
        const memoryType = getMultiSessionMemoryTypeById(getState(), id);
        const updatedType = {
            ...memoryType,
            [setting]: settingUpdate
        };
        const update = updateMultiSessionMemoryType(id, updatedType, skipLocalStorageUpdate);
        return dispatch(update);
    };
}
export function updateMultiSessionMemoryCount(num, skipLocalStorageUpdate = false) {
    return (dispatch) => {
        const update = chatGPTReducer.updateField("multiSessionMemoryCount", num);
        if (localStorage && !skipLocalStorageUpdate) {
            localStorage.setItem("multiSessionMemoryCount", JSON.stringify(num));
        }
        return dispatch(update);
    };
}
export function updateMemoryAugmentationPromptTemplate(memoryAugmentationPromptTemplate, skipLocalStorageUpdate = false) {
    return (dispatch) => {
        const update = chatGPTReducer.updateField("memoryAugmentationPromptTemplate", memoryAugmentationPromptTemplate);
        if (localStorage && !skipLocalStorageUpdate) {
            localStorage.setItem("memoryAugmentationPromptTemplate", JSON.stringify(memoryAugmentationPromptTemplate));
        }
        return dispatch(update);
    };
}
export function updateMemoryCreationPromptTemplate(memoryCreationPromptTemplate, skipLocalStorageUpdate = false) {
    return (dispatch) => {
        const update = chatGPTReducer.updateField("memoryCreationPromptTemplate", memoryCreationPromptTemplate);
        if (localStorage && !skipLocalStorageUpdate) {
            localStorage.setItem("memoryCreationPromptTemplate", JSON.stringify(memoryCreationPromptTemplate));
        }
        return dispatch(update);
    };
}
export function resetMemoryAugmentationPromptTemplate() {
    return (dispatch) => {
        dispatch(updateMemoryAugmentationPromptTemplate(DEFAULT_MEMORY_AUGMENTATION_PROMPT_TEMPLATE));
    };
}
export function resetMemoryCreationPromptTemplate() {
    return (dispatch) => {
        dispatch(updateMemoryCreationPromptTemplate(DEFAULT_MEMORY_CREATION_PROMPT_TEMPLATE));
    };
}
export function resetMultiSessionMemory() {
    return async (dispatch, getState) => {
        const accountId = getSelectedAccountId(getState());
        const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
        const result = await factory.getCompletionClient().resetMultiSessionMemory();
        if (result?.status !== "SUCCESS") {
            throw Error("Error resetting multi-session memory");
        }
        return result;
    };
}
